import { Box, Button, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconErrorFilled } from '@zillow/constellation-icons';

type ToursErrorStateProps = {
  tourCalendarPath: string;
};

const ToursErrorState = ({ tourCalendarPath }: ToursErrorStateProps) => (
  <Box data-testid="ToursSummary-errorState">
    <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
      <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconErrorFilled />} />
    </Box>

    <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
      Tour information unavailable right now
    </Heading>

    <Paragraph css={{ marginBottom: 'default' }}>
      Refresh the page to try again, or open your tour calendar to see upcoming tours.
    </Paragraph>

    <Button tone="brand" emphasis="filled" asChild>
      <a href={tourCalendarPath}>View calendar</a>
    </Button>
  </Box>
);

export default ToursErrorState;
